import {ContextAware, DetailContext} from "@/app/contexts/detail.context";

export default class EventBase {
  callback: any;

  async getCallBack(context: ContextAware, payload: any, rawPayload: any): Promise<any> {
    return this.callback(payload, rawPayload);
  }
}
